import { Button } from '../../../components/button'

export default function ResendEmailConfirmationSuccess({ onClose }) {
  return (
    <form className='wrapper' onSubmit={onClose}>
      <div className='flex alignCenter flexDirectionColumn'>
        <h2 className='title'>Check your email!</h2>
      </div>

      <div className='flex flexDirectionColumn alignCenter'>
        <p className='description '>Confirmation email has been resent</p>
        <Button type='submit' className='flatBtn confirm'>
          Close
        </Button>
      </div>

      <style jsx>{`
        .title {
          padding: 0 0 0.8rem;
          line-height: 3.6rem;
          font-size: 3.2rem;
        }

        .description {
          padding: 0 0 2.3rem;
          line-height: 2.1rem;
          font-size: 1.6rem;
        }

        .wrapper {
          position: relative;
          width: 43.6rem;
          padding: 2.6rem 2rem 4.1rem;
          background: #fff;
          border-radius: 1rem;
          text-align: center;
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            padding: 1.6rem 2rem 4.1rem;
          }

          :global(.confirm) {
            position: fixed;
            width: calc(100% - 2.8rem);
            bottom: 2.1rem;
          }
        }
      `}</style>
    </form>
  )
}
